import Icon from 'veui/components/Icon'

Icon.register({
  'chart-trend': {
    paths: [
      {
        d: 'M704 672a32 32 0 01-32 32H96a32 32 0 01-32-32V96a32 32 0 0164 0v544h544a32 32 0 0132 32zm-32-480H544a32 32 0 000 64h50.74L448 402.75 342.63 297.37a32 32 0 00-45.26 0l-128 128a32 32 0 0045.26 45.26L320 365.25l105.37 105.38a32 32 0 0045.26 0L640 301.26V352a32 32 0 0064 0V224a32 32 0 00-32-32z'
      }
    ],
    width: '768',
    height: '768'
  }
})
